import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  title: {
    margin: 0,
    marginBottom: 15,
    fontSize: 16,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  text: {
    display: 'block',
    maxWidth: 150,
    width: '100%',
    fontSize: 15,
    color: theme.custom.darkBlue,
    [theme.breakpoints.down('xs')]: {
      maxWidth: '65%',
    },
  },
  percents: {
    fontSize: 15,
    fontWeight: 700,
  },
  darkBlue: {
    color: theme.custom.darkBlue,
  },
  greyBlue: {
    color: '#5B7B9D',
  },
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
  },
}));
